import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-amianto-giudiziale-view',
  templateUrl: './form-amianto-giudiziale-view.component.html',
  styleUrls: ['./form-amianto-giudiziale-view.component.css']
})
export class FormAmiantoGiudizialeViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
